
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmBadgeGoogle as ObiAlarmBadgeGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-badge-google.js';
 
 
 

 
 export const ObiAlarmBadgeGoogle = createComponent({
   react: React,
   tagName: 'obi-alarm-badge-google',
   elementClass: ObiAlarmBadgeGoogleElement,
   events: {
     
   }
  });
 
 